export const geoSites = 
  [ "da-dk", "de-de", "es-es","es-mx","fi-fi","fr-fr","it-it", "ja-jp", "ko-kr", "nl-nl","no-no","pl-pl",
      "pt-br", "ru-ru", "sv-se", "tr-tr","zh-cn"]
export const defaultLocale = "en-us"